import React, { useContext, useState } from "react";
import { useCookies } from "react-cookie";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";
import { Modal } from "notes";
import { Layout } from "../Layout";
import {
  TimeContext,
  EventContext,
  AnalyticsContext,
  BrandAd,
} from "Components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(fas, fab, far);

export const Register = React.memo(({ onSuccess }) => {
  const { time } = useContext(TimeContext);
  const { event } = useContext(EventContext);
  const { logClick, logVideoAction } = useContext(AnalyticsContext);
  const [cookies, setCookie] = useCookies();

  const [open, setOpen] = useState(false);
  const [video, setVideo] = useState(null);

  const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
  const storageDirectory = event.storageDirectory;

  const {
    desktop: artistDesktop,
    mobile: artistMobile,
  } = event.register.artistImage;

  let desktopImage = `${api}/o/${storageDirectory}%2F${artistDesktop}?alt=media`;
  let mobileImage = `${api}/o/${storageDirectory}%2F${artistMobile}?alt=media`;

  let brandImg0 = `${api}/o/${storageDirectory}%2F${event.register.brandImages[0]}?alt=media`;
  let brandImg1 = `${api}/o/${storageDirectory}%2F${event.register.brandImages[1]}?alt=media`;

  const {
    heading: heroVideoHeading,
    video: heroVideo,
  } = event.callToActions.heroVideo;

  const setModalVisible = (bool, videoLink, videoTitle) => {
    setVideo(videoLink);
    setOpen(bool);
    logVideoAction({ bool, videoLink, videoTitle });
  };

  return (
    <Layout showHeader registration flexGrow showFooter>
      <RegWrapper>
        <Main>
          <ContentWrapper>
            <BrandAd set={0} headingBorder />
            <BrandImage background={brandImg0} />
          </ContentWrapper>
        </Main>

        <ArtistImage desktopImage={desktopImage} mobileImage={mobileImage}>
          <Overlay>
            <h2>{ReactHtmlParser(heroVideoHeading)}</h2>
            <PlayIcon
              onClick={() =>
                setModalVisible(true, heroVideo, "Hero/Artist Video")
              }
            >
              <FontAwesomeIcon icon={["far", "play-circle"]} />
            </PlayIcon>
          </Overlay>
        </ArtistImage>
      </RegWrapper>

      <VideoModal size="large" open={open} setOpen={setModalVisible}>
        <VideoModalContainer>
          <Video
            src={video}
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          />
        </VideoModalContainer>
      </VideoModal>
    </Layout>
  );
});

// ======== CONTENT / LEFT SIDE ======== //

const RegWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
  width: 100%;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    flex-direction: row;
  }
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    margin-right: 15px;
  }
`;

const ContentWrapper = styled.div`
  background-color: #000013;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    width: 450px;
    flex: 1;
    flex-direction: column;
  }
`;

const BrandImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 56.25%;
  background-image: url(${(props) => props.background});
  background-size: cover;
  background-position: top right;
`;

// ======== ARTIST IMAGE / RIGHT SIDE ======== //

const ArtistImage = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: start;
  background-image: url(${(props) => props.mobileImage});
  background-size: cover;
  background-position: center;
  padding-top: 56.25%;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    background-image: url(${(props) => props.desktopImage});
    flex: 1;
    padding: 0;
  }
`;

const Overlay = styled.div`
  padding: 25px;
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  max-width: 315px;

  h2 {
    margin: 0;
    text-transform: uppercase;
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    position: absolute;
    bottom: 0;
    left: 0;
  }
`;

const PlayIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 42px;

  path {
    fill: #ffffff;
  }
`;

// ======== MODAL ======== //

const VideoModal = styled(Modal)`
  justify-content: center;
  min-height: unset;
  position: relative;

  svg {
    top: 10px;
    right: 10px;
  }
`;

const VideoModalContainer = styled.div`
  padding-top: 56.25%;
  position: relative;
`;

const Video = styled.iframe`
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
  border: 0;
`;
